var $ee78ddcbe25852bb$exports = {};
$ee78ddcbe25852bb$exports = {
    "replaceMessage": `Bestand neerzetten om te vervangen`
};


export {$ee78ddcbe25852bb$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
